<template>
  <basic-container>
    <el-form
      v-show="searchBoxFlag"
      ref="searchFormRef"
      :model="query"
      label-width="100px"
      margin-top="0"
      :rules="rules"
    >
      <el-row :gutter="0">
        <el-col :span="6">
          <!-- <el-form-item label="速记码" prop="shortCode">
            <el-input
              v-model="query.shortCode"
              @input="propertyFilter()"
              placeholder="速记码"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="小区分组" prop="communityGroup">
            <el-select
              style="width: 100%"
              v-model="query.communityGroup"
              @change="communityGroupChangeHandler"
            >
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="小区名称" prop="propertyId">
            <avue-input-tree
              style="width: 100%"
              node-key="id"
              :props="defaultProps"
              default-expand-all
              v-model="query.propertyId"
              placeholder="请选择小区"
              type="select"
              @change="communityIdChange"
              :dic="allPropertyListCopy"
            >
            </avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="房产类型" prop="useType">
            <el-select v-model="query.useType" placeholder="房产类型" clearable style="width: 100%">
              <el-option
                v-for="item in allUseTypes"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="细分费项" prop="feeSort">
            <el-select v-model="query.feeSort" placeholder="全部" clearable style="width: 100%">
              <el-option
                v-for="item in allSortTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="票据号" prop="invoiceNo">
            <el-input v-model="query.invoiceNo" placeholder="票据号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费人" prop="householdName">
            <el-input v-model="query.householdName" placeholder="缴费人" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="全部" clearable style="width: 100%">
              <el-option
                v-for="item in allPayTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费来源" prop="payCost">
            <el-select v-model="query.payCost" placeholder="全部" clearable style="width: 100%">
              <el-option
                v-for="item in allPayCostList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费日期 从" prop="dateRange">
            <el-date-picker
              style="width: 45%"
              v-model="query.dateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              clearable
            >
            </el-date-picker>
            <div style="width: 10%; display: inline-flex; justify-content: center">到</div>
            <el-date-picker
              style="width: 45%"
              v-model="query.dateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              native-type="submit"
              @click.prevent="submitSearchForm"
              >搜索</el-button
            >
            <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"
          >导 出
        </el-button>
        <span>
          {{ '应缴金额:' + shouldAmountSum + '元 ' + '实收金额:' + payAmountSum + '元 ' }}
        </span>
      </template>
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot="shouldAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.shouldAmount) }}</span>
      </template>
      <template slot="delayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.delayAmount) }}</span>
      </template>
      <template slot="derateAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.derateAmount) }}</span>
      </template>
      <template slot="accountpayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.accountpayAmount) }}</span>
      </template>
      <template slot="couponAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.couponAmount) }}</span>
      </template>
      <template slot="depositAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.depositAmount) }}</span>
      </template>
      <template slot="payAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.payAmount) }}</span>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          v-if="scope.row.feeSortCount !== ''"
          @click="printBill(scope.row)"
          >票据打印
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-operation"
          v-if="showAuditBtn(scope.row.feeSortCount)"
          @click="feeReturnApply(scope.row.id)"
          >退款申请
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-s-operation"
          v-if="showInvoiceApplyBtn(scope.row)"
          @click="openApplyInvioceDialog(scope.row)"
          >发票开具
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="showInvoiceApplyBtn(scope.row)"
          @click="openInvoicePrintJournal(scope.row)"
          >打印日志
        </el-button>
        <div v-if="!showInvoiceApplyBtn(scope.row)" style="color: red">已开电子发票</div>
        <el-button v-if="permissionList.detailBtn" type="text" size="small" icon="el-icon-view" @click="openMoreDetail(scope.row)"
          >缴费详情
        </el-button>
      </template>
      <template slot="feeSort" slot-scope="scope">
        <el-tag>{{ feeSortShow(scope.row) }}</el-tag>
      </template>
    </avue-crud>
    <printPreview ref="printPreview" @saveF5="onLoad"></printPreview>
    <fee-return-apply-dialog
      ref="feeReturnApplyDialog"
      @closeApplyForm="onLoad"
    ></fee-return-apply-dialog>
    <InvoiceApplyDialog ref="invoiceApplyDialog" @submit="applyForInvoice" />
    <invoicePrintJournal
      v-if="invoicePrintJournalVisible"
      :visible.sync="invoicePrintJournalVisible"
      :feePayId="invoicePrintJournalId"
    ></invoicePrintJournal>
    <MoreDetail
      v-if="isMoreDetailShow"
      :visible.sync="isMoreDetailShow"
      :id="detailId"
    ></MoreDetail>
    <Export
      v-if="isExportShow"
      :visible.sync="isExportShow"
      :query="query"
      :allPayTypeList="allPayTypeList"
      :allPayCostList="allPayCostList"
    ></Export>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getTreeExcel,
  payPageTree,
  payPageChildren,
  remove,
  update,
  beforeOpenApply,
  getUseTypes,
} from '@/api/v4ward/paylist/feepaylist';
import { invoiceIssuePositive } from '@/api/v4ward/payrecord/index';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import { getDictionary, getCommunityGroupList } from '../../../api/common';
import _ from 'lodash';
import printPreview from '@/views/v4ward/pay/printdialog/printPreview';
import feeReturnApplyDialog from '@/views/v4ward/feereturn/feereturn-apply';
import InvoiceApplyDialog from './invoice-apply-dialog';
import invoicePrintJournal from './invoice-print-journal.vue';
import MoreDetail from './more-detail.vue';
import Export from './export.vue';
import searchFromShow from '@/components/search-form-show/index';

export default {
  components: {
    printPreview,
    feeReturnApplyDialog,
    InvoiceApplyDialog,
    invoicePrintJournal,
    MoreDetail,
    Export,
    searchFromShow,
  },
  data() {
    return {
      searchBoxFlag: true,
      searchHeight: '',
      defaultProps: {
        children: 'children',
        label: 'title',
        value: 'id',
      },
      communityGroupList: [],
      invoicePrintJournalId: '',
      invoicePrintJournalVisible: false,
      invoicePrintJournalData: [],
      isMoreDetailShow: false,
      isExportShow: false,
      //如果已经根据速记码查询过了小区信息则为true
      propertyIsQuery: false,
      payAmountSum: '',
      shouldAmountSum: '',
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [],
      allPropertyListCopy: [],
      allSortTypeList: [],
      allPayCostList: [],
      payCostList: [],
      propertyName: '',
      form: {},
      query: {
        communityGroup: '',
        shortCode: '',
        propertyId: '',
        feeSort: '',
        useType: '',
        householdName: '',
        invoiceNo: '',
        payType: '',
        payCost: '',
        dateFrom: '',
        dateTo: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        excelBtn: false,
        selection: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '地址',
            prop: 'roomName',
            width: 180,
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
            slot: true,
            align: 'right',
          },

          {
            label: '减免金额',
            prop: 'derateAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '账户抵扣',
            prop: 'accountpayAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '优惠券抵扣',
            prop: 'couponAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '押金抵扣金额',
            prop: 'depositAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '订单状态',
            prop: 'payStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_status',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
          {
            label: '缴费来源',
            prop: 'payCost',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_cost',
            dataType: 'number',
          },
          {
            label: '电子发票',
            prop: 'invoicingFlag',
            dicData: [
              { label: '未开票', value: 0 },
              { label: '已开票', value: 1 },
            ],
            dataType: 'number',
          },
          {
            label: '收费摘要',
            prop: 'payRemark',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.paydetailrecords_add, false),
        viewBtn: this.vaildData(this.permission.paydetailrecords_view, false),
        delBtn: this.vaildData(this.permission.paydetailrecords_delete, false),
        editBtn: this.vaildData(this.permission.paydetailrecords_edit, false),
        detailBtn: this.vaildData(this.permission.paydetailrecords_detail, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created() {
    this.initDefaultDateRange();
    this.initSortTypeList();
    this.initUseTypes();
    this.initPayTypeList();
    this.initPayCostList();
    let this_ = this;
    getCommunityGroupList().then((res) => {
      this.communityGroupList = res.data;
      this.query.communityGroup = res.data[0].dictKey;
      this.initPropertyList((data) => {
        this.query.propertyId = data[0].id;
        this.query = _.cloneDeep(this_.query);
        this.onLoad();
      });
    });
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279;
    },
    /* 缴费详情弹框 */
    openMoreDetail(row) {
      this.detailId = row.id;
      this.isMoreDetailShow = true;
    },
    communityGroupChangeHandler(val) {
      let this_ = this;
      this.allPropertyListCopy = [];
      this.initPropertyList((data) => {
        this.query.propertyId = data[0].id;
        this.query = _.cloneDeep(this_.query);
      });
    },
    openInvoicePrintJournal(row) {
      this.invoicePrintJournalId = row.id;
      this.invoicePrintJournalVisible = true;
    },
    //打开申请发票弹窗
    openApplyInvioceDialog(row) {
      console.log('row');
      console.log(row);
      this.$refs.invoiceApplyDialog.openDialog(row);
    },
    //申请发票
    applyForInvoice(data, cb) {
      let loading = this.$loading();
      invoiceIssuePositive(data)
        .then((res) => {
          loading.close();
          this.$message({
            message: res.msg,
            type: res.success ? 'success' : 'error',
          });
          cb();
          this.onLoad();
        })
        .catch((res) => {
          loading.close();
          console.log('res==>', res);
          cb();
        });
    },
    showAuditBtn(feeSortCount) {
      return feeSortCount !== '' && this.vaildData(this.permission.feereturn_apply, false);
    },
    showInvoiceApplyBtn(row) {
      let notApplied = row.invoicingFlag == 0;
      let rightStatus = row.payStatus == 1;
      // notApplied = true;
      return notApplied && rightStatus && this.vaildData(this.permission.invoice_apply, false);
    },
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.propertyId = '';
      }
      if (this.allPropertyListCopy.length > 0) {
        // this.query.propertyId = this.allPropertyListCopy[0].id;
        this.query = Object.assign({}, this.query, { propertyId: this.allPropertyListCopy[0].id });
      } else this.query.propertyId = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query, 'communityGroup');
      this.initDefaultDateRange();
      this.propertyFilter();
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    onLoad(page) {
      if (this.propertyIsQuery && !this.query.propertyId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.propertyId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if (!this.query.propertyId) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          payPageTree(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipageQuery.total;
            this.data = data.ipageQuery.records;
            this.shouldAmountSum = data.shouldAmountSum;
            this.payAmountSum = data.payAmountSum;
            this.loading = false;
            this.selectionClear();
          });
        });
        return;
      }
      payPageTree(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.ipageQuery.total;
          this.data = data.ipageQuery.records;
          this.shouldAmountSum = data.shouldAmountSum;
          this.payAmountSum = data.payAmountSum;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.query.dateFrom = this.getCurrentMonthFirst() + ' 00:00:00.000';
      this.query.dateTo = this.getCurrentMonthLast() + ' 23:59:59.999';
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPropertyList(cb) {
      let this_ = this;
      getOptionNode({ communityGroup: this_.query.communityGroup }).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
        cb(data.data);
      });
    },

    initSortTypeList: function () {
      getDictionary('fee_sort').then((data) => {
        this.allSortTypeList = data.data;
      });
    },


    initUseTypes: function () {
      getUseTypes().then((data) => {
        this.allUseTypes = data.data;
      });
    },

    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },

    initPayCostList: function () {
      getDictionary('pay_cost').then((data) => {
        console.log('data==>', data);
        this.allPayCostList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.isExportShow = true;
    },
    feeSortShow(row) {
      if (row.feeSortCount) return row.feeSortCount;
      else if (row.feeSort) return this.feeSortToName(row.feeSort);
    },
    feeSortToName(feeSort) {
      var feeSortName = '';
      this.allSortTypeList.forEach(function (value, index, array) {
        if (value.dictKey == feeSort) {
          feeSortName = value.dictValue;
          return;
        }
      });
      return feeSortName;
    },

    printBill(row) {
      this.$refs.printPreview.openPayChargePrintPreDialog(row.payBillNo);
    },
    feeReturnApply(feeId) {
      beforeOpenApply(feeId).then((res) => {
        var data = res.data;
        if (data.code === 201) {
          this.$refs.feeReturnApplyDialog.openDialogForm('退款申请', feeId);
        } else {
          this.$alert(data.msg, '提示信息', {
            confirmButtonText: '确定',
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}

.el-dialog__body .el-card__body {
  padding: 0;
}

.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>
